// Copyright (c) Ensho Health, 2021 to present

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { ROUTES } from '../../constants.js';
import actions from '../../state-manager/action';
import { StyledPage, StyledMessage } from './Welcome.styles.js';
import FormWelcome from '../../component/welcome/FormWelcome.js';

const Welcome = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  function onBack() {
    history.push(ROUTES.LOGIN);
  }

  async function onSubmitResetPassword(info) {
    try {
      dispatch(actions.auth.resetPassword(info));
    } catch (error) {
      setErrorMessage(error.message);
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      dispatch(actions.auth.loginWithToken({ token }));
    } else {
      history.push(ROUTES.LOGIN);
    }
  }, [dispatch, history, location]);

  useEffect(() => {
    if (auth.transaction) {
      dispatch(actions.auth.handleNewTransaction());
    }
  }, [dispatch, auth.transaction]);

  if (
    auth.transaction?.status === 'MFA_ENROLL_ACTIVATE' &&
    !auth.transaction?.factor?.activation?.qrcode?.href
  ) {
    setErrorMessage('Impossible to find your QR code');
  }

  const displayResetPasswordForm =
    !auth.transaction || auth.transaction?.status === 'PASSWORD_RESET';
  const displayQrCode = auth.transaction?.status === 'MFA_ENROLL_ACTIVATE';
  return (
    <StyledPage>
      {displayResetPasswordForm && (
        <FormWelcome
          onSubmit={onSubmitResetPassword}
          loading={auth.loading}
          errorMessage={errorMessage || auth.error}
          onBack={onBack}
        />
      )}
      {displayQrCode && (
        <StyledMessage>
          <div style={{ textAlign: 'center' }}>
            <img
              src={auth.transaction?.factor?.activation?.qrcode?.href}
              alt="MFA enroll QR code"
            />
          </div>
          <p style={{ fontSize: 18, marginTop: 30, textAlign: 'center' }}>
            Scan the QR code above with your smartphone&apos;s Okta Verify app
            to activate multi-factor authentication
          </p>
        </StyledMessage>
      )}
    </StyledPage>
  );
};

export default Welcome;
